














import { Component, Emit, Prop, PropSync, Ref, Vue, Watch } from 'vue-property-decorator'
import { Action } from 'vuex-class'

import { VuesaxButtonTypes, VuesaxColors } from '@/shims-vuesax'

@Component
export default class VsDialog extends Vue {
  @PropSync('active', { type: Boolean, required: true })
  syncedActive!: boolean

  @Prop({ type: String, required: true })
  readonly title!: string

  @Prop({ type: String, required: true })
  readonly buttonText!: string

  @Prop({ type: String, default: 'filled' })
  readonly buttonType!: VuesaxButtonTypes

  @Prop({ type: String, default: 'primary' })
  readonly color!: VuesaxColors

  @Ref()
  readonly prompt!: Vue & {
    isPrompt: boolean
    fActive: boolean
  }

  @Watch('active')
  async onActiveChange (isActive: boolean) {
    this.prompt.isPrompt = false
    this.prompt.fActive = isActive

    await this.updateModalCount(isActive)
  }

  @Action
  updateModalCount!: (isActive: boolean) => Promise<void>

  @Emit()
  close () {
    this.syncedActive = false
  }

  @Emit()
  accept () {
    this.syncedActive = false
  }
}
